function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
var BillsFilled = function BillsFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size || 16,
    height: props.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: props.size > 16 ? 0 : 0.8,
    stroke: props.size <= 16 ? props.color ? props.color : "#242328" : "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || "#222222",
    fillRule: "evenodd",
    d: "M6.5 1.75A2.25 2.25 0 0 0 4.25 4v17.5a.75.75 0 0 0 1.163.626l1.92-1.268 1.92 1.268a.75.75 0 0 0 .827 0L12 20.858l1.92 1.268a.75.75 0 0 0 .827 0l1.92-1.268 1.92 1.268a.75.75 0 0 0 1.163-.626V4a2.25 2.25 0 0 0-2.25-2.25zM12.75 7a.75.75 0 0 0-1.5 0v.303a4 4 0 0 0-.174.03c-.392.076-.845.235-1.214.587l-.003.004c-.645.623-.813 1.66-.334 2.455l.002.004c.507.833 1.473 1.117 2.05 1.279h.002l.607.168c.558.171.867.342 1.002.566a.505.505 0 0 1-.091.6c-.085.081-.228.153-.463.2a4.2 4.2 0 0 1-.792.054c-.307 0-.6-.095-.8-.245a.66.66 0 0 1-.288-.546.75.75 0 0 0-1.5.021c.011.756.382 1.346.89 1.726.328.246.712.406 1.106.485V15a.75.75 0 0 0 1.5 0v-.303q.085-.013.171-.03c.392-.076.845-.235 1.214-.588l.003-.003c.64-.619.824-1.649.333-2.458-.46-.757-1.299-1.055-1.857-1.225l-.018-.006-.615-.17h-.002c-.641-.18-1.01-.35-1.17-.612a.52.52 0 0 1 .091-.602c.085-.08.228-.152.463-.198.238-.047.505-.055.792-.055.307 0 .6.095.8.245a.66.66 0 0 1 .288.546.75.75 0 0 0 1.5-.022 2.16 2.16 0 0 0-.89-1.725 2.75 2.75 0 0 0-1.103-.484z",
    clipRule: "evenodd"
  }));
};
export default BillsFilled;
BillsFilled.displayName = 'BillsFilled';